import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Button, ButtonWithLoading } from '@spark/ui-components/components/Button';
import { colorBlue, colorBackground, colorText } from '@spark/ui-components/theme';

const ConfirmDeleteModal = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  title = "Confirmar exclusão",
  message = "Esta ação é irreversível. Tem certeza que deseja excluir este registro?",
  confirmButtonText = "Excluir",
  confirmButtonVariant = "danger",
  loadingText = "Excluindo..."
}) => <StyledModal show={show} onHide={onClose} centered>
    <div className="modal-content">
      <Icon className="lnr lnr-cross-circle" />
      <Title>{title}</Title>
      <Message>
        {message}
      </Message>
      <ButtonGroup>
        <Button variant="secondary" onClick={onClose} disabled={loading ? 'true' : undefined}>Cancelar</Button>
        <ButtonWithLoading variant={confirmButtonVariant} onClick={onConfirm} loading={loading ? 'true' : undefined} loadingText={loadingText}>
          {confirmButtonText}
        </ButtonWithLoading>
      </ButtonGroup>
    </div>
  </StyledModal>;

ConfirmDeleteModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  loadingText: PropTypes.string
};
export default ConfirmDeleteModal; // ───────────── STYLES ─────────────

const StyledModal = styled(BootstrapModal)`
  .modal-dialog {
    max-width: 400px;
  }

  .modal-content {
    background-color: ${colorBackground};
    border: none;
    padding: 40px 30px;
    text-align: center;
    color: ${colorText};
    border-radius: 4px;
  }
`;
const Icon = styled.span`
  font-size: 28px;
  color: ${colorBlue};
  margin-bottom: 16px;
`;
const Title = styled.h4`
  font-weight: bold;
  margin-bottom: 12px;
`;
const Message = styled.p`
  font-size: 14px;
  margin-bottom: 24px;
`;
const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;

  button {
    min-width: 90px;
    padding: 6px 16px;
  }
`;
